// src/portfolio.js

/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hit the Code Labs",
  title: "Data, automation, and GIS for real-world operations",
  subTitle: emoji(
    "We design working systems—AI prototypes, ETL pipelines, and geospatial tools—that help teams act with confidence. We measure what matters and build only what your team will use."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  whatsapp: "https://api.whatsapp.com/send/?phone=593980205137",
  github: "https://github.com/hitthecodelabs",
  linkedin: "https://www.linkedin.com/in/jeanpaulpaes/",
  instagram: "https://www.instagram.com/hitthecode/",
  // gmail: "jpaul@hitthecodelabs.com",
  telegram: "https://t.me/hitthecodelabs",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What we do",
  subTitle: "Practical AI, automation, and GIS—focused on measurable outcomes and fit with real operations",
  skills: [
    emoji(
      "⚡ Design and ship small, working systems: AI prototypes, ETL/ELT pipelines, and geospatial tools."
    ),
    emoji("⚡ Build dashboards, alerts, and reporting that teams actually use—versioned, documented, and reproducible."),
    emoji(
      "⚡ Validate with metrics (accuracy, latency, time saved), follow least-privilege access, and hand over clean runbooks."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "ArcGIS",
      fontAwesomeClassname: "fas fa-compass"
    },
    // {
    //   skillName: "Artificial Intelligence",
    //   fontAwesomeClassname: "fas fa-brain"
    // },
    {
      skillName: "Tensorflow",
      fontAwesomeClassname: "fas fa-chess-king"
    },
    {
      skillName: "Pytorch",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Google Cloud",
      fontAwesomeClassname: "fas fa-cloud"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Databases",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Django",
      fontAwesomeClassname: "fab fa-dyalog"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Solidity",
      fontAwesomeClassname: "fab fa-ethereum"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Escuela Superior Politécnica del Litoral",
      logo: require("./assets/images/espollogo.png"),
      subHeader: "Bachelor of Business Administration",
      duration: "Present",
      desc: "Process automation and efficiency improvement across various industries.",
      descBullets: [
        // "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Applied data analysis techniques to real-world business operations."
      ]
    },
    {
      schoolName: "University of Toronto",
      logo: require("./assets/images/utoronto.jpg"),
      subHeader: "Specialization of Self-Driving Cars",
      duration: "June 2020",
      desc: "Computer vision for autonomous vehicles usning deep learning techniques, OpenCV and Python",
      descBullets: [
        "Implemented methods for static and dynamic object detection, localization, and mapping.",
        "Developed algorithms for visual perception, vehicle control, behavior planning, and maneuver planning.",
        "Worked with real data sets from autonomous vehicles and 3D pedestrian modeling."
      ]
    },
    {
      schoolName: "Michigan University",
      logo: require("./assets/images/michiganu.png"),
      subHeader: "Specialization of Applied Data Science with Python",
      duration: "May 2019",
      desc: "Coursework included Data Processing, Data Visualization, and Machine Learning models.",
      descBullets: [
        "Mastered data manipulation and cleaning using pandas and numpy.",
        "Performed applied text mining and social network analysis.",
        "Created advanced data visualizations and charts to communicate insights effectively."]
    },
    {
      schoolName: "DeepLearning.AI",
      logo: require("./assets/images/dlai.jpg"),
      subHeader: "Specialization of Natural Language Processing",
      duration: "June 2020",
      desc: "Advanced techniques in NLP, including attention models and transformers.",
      descBullets: [
        "Designed applications for question-answering, sentiment analysis, and text summarization.",
        "Built models using probabilistic approaches, vector spaces, and attention mechanisms.",
        "Implemented sequence models and machine translation tools."
      ]
    },
    {
      schoolName: "Massachusetts Institute of Technology",
      logo: require("./assets/images/mit_logo.png"),
      subHeader: "Specialization of Machine Learning with Python",
      duration: "December 2020",
      desc: "Comprehensive curriculum on machine learning algorithms and implementation.",
      descBullets: [
        "Implemented regression, classification, and clustering algorithms from scratch.",
        "Analyzed models for accuracy, overfitting, and regularization.",
        "Applied machine learning solutions to complex datasets."
      ]
    },
    {
      schoolName: "Amazon Web Services (AWS)",
      logo: require("./assets/images/awslogo.png"), // Asegúrate de tener un logo de aws en tu carpeta de imágenes o cambia el nombre aquí
      subHeader: "AWS Cloud Practitioner Essentials",
      duration: "August 2025",
      desc: "Comprehensive understanding of the AWS Cloud platform, including cloud concepts, security, compliance, and technology.",
      descBullets: [
        "Mastered core AWS services and their common use cases.",
        "Learned billing, account management, and pricing models.",
        "Acquired skills in basic security and compliance aspects of the AWS platform."
      ]
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "AWS Cloud Engineer",
      company: "Importadora Grupo Jordan",
      companylogo: require("./assets/images/importadora_grupo_jordan_logo.jpg"),
      // date: "June 2018 – Present",
      desc: "Led the design and implementation of a cloud-native billing solution on AWS, from initial architecture to deployment. Full infrastructure automation (IaC) and leadership in site-to-site VPN integration.",
      descBullets: [
        // "Full infrastructure automation (IaC) with AWS CDK and leadership in site-to-site VPN integration with SAP systems.",
        // ""
      ]
    },
    {
      role: "Software Developer",
      company: "Lubrication and Vibration Systems",
      companylogo: require("./assets/images/luvib_sys_logo.jpg"),
      // date: "May 2017 – May 2018",
      desc: "Delivered web scraping automation workflows in the back-end and REST endpoints to support internal tools and client workflows"
    },
    {
      role: "Data Analyst",
      company: "Svetlanross Consulting",
      companylogo: require("./assets/images/svetlan.webp"),
      // date: "Jan 2015 – Sep 2015",
      desc: "Collected social media data during the 2021 Ecuadorian Presidential Campaign. Creation and delivery of real-time reports using automated broadcast channels"
    },
    {
      role: "Data Analyst",
      company: "Quikzer",
      companylogo: require("./assets/images/quikzer.png"),
      // date: "Jan 2015 – Sep 2015",
      desc: "Drove LLM-based products from prototype to initial production (prompt design, evaluation, guardrails). Definition of engineering standards for API design, CI/CD, and telemetry to accelerate iteration cycles."
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Automated Billing System",
      subtitle: "Develped a $60K / year Solution to automate their billing and invoicing process. An alternative to SAP data entry that reduced errors by 95% and sped up the process by 75%.",
      image: require("./assets/images/grupojo.png"),
      imageAlt: "Automated Billing System",
      footerLink: [
        // {name: "Certification", url: ""},
        // {
        //   name: "Final Project",
        //   url: "https://pakistan-olx-1.firebaseapp.com/"
        // }
      ]
    },
    {
      title: "Sustainability for EUDR Compliance",
      subtitle:
        "Developed an automated polygon quality analysis tool for cocoa; over 2,500 hectares of cocoa validated for EUDR regulation. Reduced manual QA time by 80%.",
      image: require("./assets/images/cargill.png"),
      imageAlt: "Sustainability for EUDR Compliance",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },
    {
      title: "Camaroneras 4.0 Finalist",
      subtitle:
        "Finalist proposal in the International CAMARONERAS 4.0 competition in partnership with ESPOL: Biomass Calculation System based on machine learning to optimize shrimp production.",
      image: require("./assets/images/lanec.png"),
      imageAlt: "Camaroneras 4.0 Finalist",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        // },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "PROJECTS",
  subtitle: emoji(
    "HERE ARE THE OPEN-SOURCE PROJECTS AND INSTRUCTIONAL CODE"
  ),

  talks: [
    {
      title: "Github Repositories",
      subtitle: "Open-source projects, guides, how-to's, lessons, etc",
      slides_url: "https://github.com/hitthecodelabs",
      // event_url: "https://www.facebook.com/events/2339906106275053/"
      event_url: "https://github.com/hitthecodelabs?tab=repositories"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Us ☎️"),
  subtitle:
    "Discuss a project? Our contact info is open for all.",
  number: "+593 980 205 137",
  email_address: "jpaul@hitthecodelabs.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
